// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"ae420e56","6850":"49d34fc4"}[chunkId] + ".chunk.css";
};